import { render, staticRenderFns } from "./AgentListAddNew.vue?vue&type=template&id=a259b84a&"
import script from "./AgentListAddNew.vue?vue&type=script&lang=js&"
export * from "./AgentListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./AgentListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports